const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignmentMessaging', ['DynamicMessages', '$translate', '$sce',  function(DynamicMessages, $translate, $sce) {
  return {
    restrict: 'E',
    scope: {
      values: '=',
      addMessage: '&',
      content: '=',
      editOnly: '@?'
    },
    template: require('../../../templates/directives/assignments/assignment-messaging.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.editOnly = $scope.editOnly && $scope.editOnly === 'true';
      self.translations = [];

      self.uponAssignment = '';
      self.uponCompletion = '';
      self.pastDueDate = '';
      self.overdueSchedule = '';
      self.disableAssignmentOverdue = false;
      self.capWords = function(str){
        if(typeof str !== "string"){
          return str;
        }
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      };
      self.addMessage = function(message) {
        self.messages.displayDynamic = false;
        $scope.addMessage({message: message});
        self.messages.refreshList();
      };

      self.messages = {
        activeItem: null,
        displayDynamic: false,
        list: [],
        itemMap: {
          in_app: 'In-App',
          email: 'Email',
          slack: 'Slack'
        },
        deliveryCounts: {},
        formatSchedule: function(notif) {

          if (!notif.type || typeof notif.type !== 'string') {
            return '--';
          }

          if (notif.type.indexOf('created') !== -1) {
            return self.uponAssignment;
          }
          if (notif.type.indexOf('passed') !== -1) {
            return self.uponCompletion;
          }
          if (notif.type.indexOf('failed') !== -1) {
            return self.pastDueDate;
          }
          if (notif.type.indexOf('overdue') !== -1) {
            return self.overdueSchedule;
          }
          if (notif.type.indexOf('reminder') === -1) {
            return '--';
          }

          var item;
          $scope.values.reminder_messages.forEach(function(message) {
            if (message.message === notif._id) {
              item = message;
            }
          });

          if (!item || !item.time_before_due) {
            return '--';
          }

          return item.time_before_due + (item.time_before_due > 1 ? ' days' : ' day') + ' before due'
        },
        getTypes: function(item) {
          var list = '';
          var listArr = [];
          item.channels.forEach(function(channel) {
            if (!self.messages.itemMap[channel]) {
              return;
            }
            listArr.push(self.messages.itemMap[channel]);
          });
          listArr.sort();
          if(listArr.indexOf('In-App') > -1){
            var removed = listArr.splice(listArr.indexOf('In-App'),1);
            listArr.push('In-App');
          }
          for(var i = 0; i < listArr.length; i++){
            if(list !== ''){
              list = list + ' | ' + listArr[i]
            } else {
              list = listArr[i];
            }
          }
          return list;
        },
        getAudience: function(item) {
          if (!item.type) {
            return '--';
          }
          if (item.type.indexOf('assignee') !== -1) {
            return 'Assignee';
          }
          if (item.type.indexOf('escalator') !== -1) {
            return 'Escalation Contacts';
          }
          return '--';
        },
        remove: function(item) {
          // Remove from assignment - not necessarily delte
          var nrm = $scope.values.non_reminder_messages.indexOf(item._id);
          if (nrm !== -1) {
            $scope.values.non_reminder_messages.splice(nrm, 1);
          }
          var rm = -1;
          $scope.values.reminder_messages.forEach(function(message, index) {
            if (message.message === item._id) {
              rm = index;
            }
          });
          if (rm !== -1) {
            $scope.values.reminder_messages.splice(rm, 1);
          }
          var om = -1;
          $scope.values.overdue_messages.forEach(function(message, index) {
            if (message.message === item._id) {
              om = index;
            }
          });
          if (om !== -1) {
            $scope.values.overdue_messages.splice(om, 1);
          }
        },
        edit: function(item) {
          // Pass item _id into templating component
          self.messages.activeItem = item._id;
          self.messages.displayDynamic = true;
        },
        addNew: function() {
          self.messages.activeItem = null;
          self.messages.displayDynamic = true;
        },
        refreshList: function() {
          const nrm = $scope.values.non_reminder_messages || [];
          let rm = $scope.values.reminder_messages || [];
          let om = $scope.values.overdue_messages || [];
          rm = rm.map(function(item) {
            return item.message;
          });
          om = om.map(function(item) {
            return item.message;
          });
          self.disableAssignmentOverdue = om.length > 0;
          var messages = [].concat(nrm, rm, om);
          if (!messages.length) {
            self.messages.list = [];
            return;
          }

          DynamicMessages.find({
            _id: '$in,' + messages.length + ',' + messages.join(','),
            fields: '_id,company,user,scheduled,type,content_type,channels,messaging,options,name',
            'user-populate': 'first_name,last_name,full_name,email'
          }).$promise.then(function(items) {
            self.messages.list = items;
          }).catch(function(error) {
            console.log('refresherror: ', error);
          });
        }
      };

      self.messages.refreshList();

      $scope.$watch('values', function(newVal, oldVal) {
        if (!newVal || !oldVal) {
          return;
        }
        var nnrm = newVal.non_reminder_messages || [];
        var onrm = oldVal.non_reminder_messages || [];
        var nrm = newVal.reminder_messages || [];
        var orm = oldVal.reminder_messages || [];
        var nom = newVal.overdue_messages || [];
        var oom = oldVal.overdue_messages || [];
        if (nnrm.length !== onrm.length || nrm.length !== orm.length || nom.length !== oom.length) {
          // Refresh list
          self.messages.refreshList();
        }
      }, true);

      $translate([
        'assignmentMessaging.upon_assignment',
        'assignmentMessaging.upon_completion',
        'assignmentMessaging.past_due_date',
        'assignmentMessaging.overdue',
      ]).then(function (translations) {
        self.translations = translations;
        self.uponAssignment = $sce.valueOf(self.translations['assignmentMessaging.upon_assignment']);
        self.uponCompletion = $sce.valueOf(self.translations['assignmentMessaging.upon_completion']);
        self.pastDueDate = $sce.valueOf(self.translations['assignmentMessaging.past_due_date']);
        self.overdueSchedule = $sce.valueOf(self.translations['assignmentMessaging.overdue']);
      });

    }],
    controllerAs: 'messaging'
  };
}]);